import { ImgHTMLAttributes } from 'react'

import { SanityImage } from '../../groq/sanity-dispensaries/types'
import { dispensaryImageUrlFor } from '../sanity'

export const dispensaryLogoSrcProps = (
  image: SanityImage,
): Pick<ImgHTMLAttributes<HTMLImageElement>, 'src' | 'srcSet'> => {
  const src1x =
    dispensaryImageUrlFor(image.asset._ref).fit('max').height(90).auto('format').url() || ''
  const src2x =
    dispensaryImageUrlFor(image.asset._ref).fit('max').height(90).dpr(2).auto('format').url() || ''
  return {
    src: src1x,
    srcSet: `${src1x} 1x, ${src2x} 2x`,
  }
}
